import { type FC, useEffect } from 'react'
import WebpBlueGradientSplashSrc from '../../webp/blue_gradient_splash.webp'
import WebpBlueOverviewSrc from '../../webp/blue_overview.webp'
import WebpBlueSplashSrc from '../../webp/blue_splash.webp'
import WebpCheckingAccountSmallSrc from '../../webp/checking_account_sm.webp'
import WebpClientServiceDesktopSrc from '../../webp/client_service_desktop.webp'
import WebpClientServiceMobileSrc from '../../webp/client_service_mobile.webp'
import WebpEgwBlackLogoSrc from '../../webp/egw_logo.webp'
import WebpEvergreenWealthLogoSrc from '../../webp/evergreen_wealth_logo.webp'
import WebpGreenGradientSplashSrc from '../../webp/green_gradient_splash.webp'
import WebpGreenOverviewSrc from '../../webp/green_overview.webp'
import WebpGreenSplashSrc from '../../webp/green_splash.webp'
import WebpGreenTreasuriesDesktopSrc from '../../webp/green_treasuries_desktop.webp'
import WebpGreenTreasuriesMobileSrc from '../../webp/green_treasuries_mobile.webp'
import WebpLiquidTreasuriesHeaderSrc from '../../webp/liquid_treasuries_header.webp'
import WebpOrangeGradientSplashSrc from '../../webp/orange_gradient_splash.webp'
import WebpOrangeOverviewSrc from '../../webp/orange_overview.webp'
import WebpOrangeSplashSrc from '../../webp/orange_splash.webp'
import WebpPersonalPortfolioHeaderSrc from '../../webp/personal_portfolio_header.webp'
import WebpPersonalPortfolioSmallSrc from '../../webp/personal_portfolio_sm.webp'
import WebpPurpleOverviewSrc from '../../webp/purple_overview.webp'
import WebpPurpleSplashSrc from '../../webp/purple_splash.webp'
import WebpSavingsAccountSmallSrc from '../../webp/savings_account_sm.webp'

interface Img {
  src: string
}

const getImageSrc = (imgSrc: string | Img): string => {
  return typeof imgSrc === 'string' ? imgSrc : imgSrc.src
}

const WEALTH_IMAGES = [
  WebpBlueGradientSplashSrc,
  WebpBlueOverviewSrc,
  WebpBlueSplashSrc,
  WebpCheckingAccountSmallSrc,
  WebpClientServiceDesktopSrc,
  WebpClientServiceMobileSrc,
  WebpEvergreenWealthLogoSrc,
  WebpEgwBlackLogoSrc,
  WebpGreenGradientSplashSrc,
  WebpGreenOverviewSrc,
  WebpGreenSplashSrc,
  WebpGreenTreasuriesDesktopSrc,
  WebpGreenTreasuriesMobileSrc,
  WebpLiquidTreasuriesHeaderSrc,
  WebpOrangeGradientSplashSrc,
  WebpOrangeOverviewSrc,
  WebpOrangeSplashSrc,
  WebpPersonalPortfolioHeaderSrc,
  WebpPersonalPortfolioSmallSrc,
  WebpPurpleOverviewSrc,
  WebpPurpleSplashSrc,
  WebpSavingsAccountSmallSrc,
].map((img) => getImageSrc(img as string | Img))

export const WealthPreloadImages: FC = () => {
  useEffect(() => {
    const links: HTMLLinkElement[] = []

    WEALTH_IMAGES.forEach((src) => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'image'
      link.href = src
      document.head.appendChild(link)
    })

    return () => {
      links.forEach((link) => {
        document.head.removeChild(link)
      })
    }
  }, [])

  return null
}
